const fonts = {
  baseFont: 'Roboto, "Franklin Gothic Medium", Tahoma, sans-serif'
};

export default fonts;
